export default __webpack_public_path__ + "static/media/Randrake.907cd708.ttf";